import React from 'react'
import { CircleCheck, CircleX, FilePlus2, RefreshCw, Pencil, History, UserRound, Truck, Warehouse, ArrowRight } from 'lucide-react'
import { tr } from 'i18n'
import { DateTime, Vehicle } from 'components/Erp/Display'
import { Changes } from 'pages/AdminPanelPage/Blocks/AuditPanel'
import './RequestHistoryEvent.scss'

const actions = {
  approve: ['Заявка подтверждена', 'Подтвердил', CircleCheck],
  reject: ['Заявка отклонена', 'Отклонил', CircleX],
  create: ['Заявка создана', 'Создал', FilePlus2],
  resubmit: ['Заявка отправлена повторно', 'Отправил', RefreshCw],
  update: ['Заявка изменена', 'Изменил', Pencil],
}
const statuses = { pending: 'На рассмотрении', approved: 'Подтверждено', rejected: 'Отклонено' }
const sections = { base_requests: 'Заявка на базу', confirmations: 'Регистрация водителя', documents: 'Изменение документа', loads: 'Перевозка' }
const valuesOf = value => value && typeof value === 'object'
  ? ['before' in value ? value.before : value.old, 'after' in value ? value.after : value.new]
  : [null, value]

export default function RequestHistoryEvent({ item }) {
  const [title, actorLabel, Icon] = actions[item.action] || [item.action_display || item.action, 'Выполнил действие', History]
  const actor = item.actor_name || item.user_name || (item.user ? tr('Пользователь #{{value0}}', { value0: item.user }) : tr('Система'))
  const [before, after] = valuesOf(item.changes?.status)
  const [, reason] = valuesOf(item.changes?.rejection_reason || item.changes?.reason)
  const otherChanges = Object.fromEntries(Object.entries(item.changes || {}).filter(([key]) => !['status', 'rejection_reason', 'reason'].includes(key)))
  return <article className={`request-event request-event--${item.action}`} aria-label={`${tr(title)} · ${actor}`}>
    <header className="request-event__header">
      <div className="request-event__action"><span className="request-event__icon"><Icon size={23} aria-hidden="true" /></span>
        <div><h4>{tr(title)}</h4><span>{tr(sections[item.section] || 'Запись')} #{item.object_id}</span></div>
      </div>
      <div className="request-event__time"><DateTime value={item.created_at} /></div>
    </header>
    <div className="request-event__actor"><UserRound size={22} aria-hidden="true" /><div><span>{tr(actorLabel)}</span><strong>{actor}</strong></div></div>
    {(item.driver_name || item.vehicle_number || item.base_name) && <div className="request-event__context">
      {item.driver_name && <div><span><UserRound size={16} aria-hidden="true" />{tr('Водитель')}</span><strong>{item.driver_name}</strong></div>}
      {item.vehicle_number && <div><span><Truck size={16} aria-hidden="true" />{tr('Автомобиль')}</span><Vehicle number={item.vehicle_number} model={item.vehicle_model} /></div>}
      {item.base_name && <div><span><Warehouse size={16} aria-hidden="true" />{tr('База')}</span><strong>{item.base_name}</strong></div>}
    </div>}
    {(before != null || after != null) && <div className="request-event__status" aria-label={tr('Изменение статуса')}>
      <div><span>{tr('Было')}</span><strong>{tr(statuses[before] || before || '—')}</strong></div>
      <ArrowRight size={20} aria-hidden="true" />
      <div className={`request-event__result request-event__result--${after}`}><span>{tr('Стало')}</span><strong>{tr(statuses[after] || after || '—')}</strong></div>
    </div>}
    {reason && <div className="request-event__reason"><strong>{tr('Причина решения')}</strong><p>{reason}</p></div>}
    {item.description && item.description !== reason && <p className="request-event__description">{tr(item.description)}</p>}
    {Object.keys(otherChanges).length > 0 && <div className="request-event__details" data-label={tr('Что изменилось')}>
      <Changes changes={otherChanges} objectType={item.object_type} section={item.section} /></div>}
  </article>
}
